import { render } from "./BetModal.vue?vue&type=template&id=bc5926b2&scoped=true&ts=true"
import script from "./BetModal.vue?vue&type=script&lang=ts"
export * from "./BetModal.vue?vue&type=script&lang=ts"

import "./BetModal.vue?vue&type=style&index=0&id=bc5926b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5926b2"]])

export default __exports__